import React, { useEffect, useRef, useState} from 'react';
import clsx from "clsx";
import tooltipIcon from "../../images/icon-tooltip.svg";

export default function Tooltip({helpText, inline = false, wide = false}) {
    const [showHelpText, setShowHelpText] = useState(false);
    const ref = useRef();
    
    useEffect(() => {
        function handleClickOutside(event) {
            if(!ref.current){
                return;
            }
        
            if (!ref.current.contains(event.target)) {
                setShowHelpText(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    
    if(!helpText){
        return null;
    }
    
    return (
        <div ref={ref} className="md:relative lg:flex items-center">
            <button className={`product-detail__table-tooltip-button${inline ? " product-detail__table-tooltip-button--inline" : ""}`}
                    onClick={() => setShowHelpText(!showHelpText)}><img src={tooltipIcon} alt=""/>
            </button>
            {showHelpText && <p className={clsx({"product-detail__table-tooltip": true, 'product-detail__table-tooltip--wide': wide, 'product-detail__table-tooltip--full-width-mobile': inline})}>{helpText}</p>}
        </div>
    );
}